import { FlightDateSave } from "../expense/flight-date-save";

export class ExpenseSubProduct {
    count: number;
    end: number;
    price: number;
    start: number;
    flightDate: Array<FlightDateSave>
    id: number;
    notes: string;
    color: string;
    margin: string;
    priceText: string;
    showLine: true
    widthContainer: string;
    constructor(data) {
        this.count = data.count;
        this.end = data.end;
        this.price = data.price;
        this.start = data.start;
        if (data.flightDate) {
            this.flightDate = data.flightDate.map((item) => new FlightDateSave(item));
        }
       
        this.id = data.id;
        this.notes = data.notes;
        this.color = data.color;
        this.margin = data.margin;
        this.priceText = data.priceText;
        this.showLine = data.showLine
        this.widthContainer = data.widthContainer;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/subproduct/expense.ts